import create from 'zustand';

interface Payload {
  accruedInterest: number;
  pl: number;
  amount: number;
  totalTax: number;
}

interface State {
  isVisible: boolean;
  accruedInterest: number;
  pl: number;
  amount: number;
  totalTax: number;
}

interface Action {
  openTaxModal(payload?: Payload): void;
  closeTaxModal(): void;
}

type Store = State & Action;

const initialState: State = {
  isVisible: false,
  accruedInterest: 0,
  pl: 0,
  amount: 0,
  totalTax: 0,
};

export const useBondTaxStore = create<Store>((set) => ({
  ...initialState,

  openTaxModal(payload) {
    set({ isVisible: true, ...payload });
  },

  closeTaxModal() {
    set(initialState);
  },
}));
